import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {

  transform(input: Array<any>, separator = ', ', finalStep: string = null): string {
    if (finalStep && input.length > 1) {
      return `${input.slice(0, -1).join(separator)}${finalStep}${input.slice(-1)}`;
    } else {
      return input.join(separator);
    }
  }
}
